import {
    isItUndefined,
    modifyLinks,
} from '../../util/DataUtil';
import { cleanHTML } from '../utils/htmlUtils';
import ReactPlayer from "react-player";
import Image from "next/image";
import {useRouter} from "next/router";

const GraphicHeroWithVideo = ({children}) => {
    const { locale } = useRouter();

    return (
        <div
            className={`graphic-hero-video`}
        >
            <div className="inner-container">
                <div
                    className={`hero-center`}
                >
                    <div
                        className={`hero-title`}
                        dangerouslySetInnerHTML={{
                            __html: cleanHTML(
                                modifyLinks(isItUndefined(children?.field_title_graphic_hero_video), locale)
                            ),
                        }}
                    />
                    <span
                        dangerouslySetInnerHTML={{
                            __html: cleanHTML(
                                modifyLinks(isItUndefined(children?.field_description_graphic_hero_v), locale)
                            ),
                        }}
                        className={`description`}
                    />

                </div>
                <div className="hero-video">
                    <div>
                        <Image
                            src={children?.field_fallback_image?.webimage}
                            alt="graphic-hero"
                            layout="fill"
                            style={{ filter: "brightness(0.4)" }}
                            priority
                        />
                        <ReactPlayer

                            url={children?.field_background_video_link[0]?.value}
                            width="100%"
                            height="100%"
                            controls={false}
                            playsinline={true}
                            playing={true}
                            loop={true}
                            muted={true}
                            style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                filter: "brightness(0.4)",
                            }}
                            config={{
                                file: {
                                    attributes: {
                                        style: {
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            // playsInline: true,
                                            // muted: true,
                                            // autoPlay: true,
                                            // loop: true,
                                            // playing: true,
                                        }
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GraphicHeroWithVideo;
